<template>
    <aside class="bd-sidebar" id="left-nav" style="display: block;">
        <nav class="bd-links" id="bd-docs-nav" aria-label="Docs navigation">
            <div class="accordion accordion-flush " id="leftNav">
                <LeftNavElement v-for="node in SectionContentNav" :node="node" :key="getID(node.name)" :level="1" />
            </div>
        </nav>
    </aside>
</template>

<script>
import LeftNavElement from "./LeftNavElement.vue";

export default {
    name: "LeftNav",
    components: { LeftNavElement },
    methods: {
        getID(name) {
            if (name) {
                let regex = /\W\.\s/g
                // Convert to lowercase and return the result.
                name = name.replace(regex, '')

                // Split name on whitespace, slashes, and ampersands and then capitalize each word.
                let words = name.split(/\W|\.\s/g);
                let capitalizedWords = words.map(word => {
                    return word.charAt(0).toUpperCase() + word.slice(1);
                });
                // Join the capitalized words with a dash and return the result.
                let result = capitalizedWords.join('');
                // if the first char in result is a number, prepend 'num'
                if (result.charAt(0).match(/\d/)) {
                    result = 'n' + result;
                }
                return result
            }
        }

    },

    data() {
        return {
            SectionContentNav: [
                {
                    name: "Executive Summary",
                    path: "/SectionContent/ExecutiveSummary"
                },
                {
                    name: "Highlighted Topics",
                    children: [
                        {
                            name: "Autonomous Vehicles",
                            path: "/HighlightedTopic/AutonomousVehicle"
                        },
                        {
                            name: "Suspected At Fault",
                            path: "/HighlightedTopic/AtFault"
                        },
                        {
                            name: "Commercial Motor Vehicles",
                            path: "/HighlightedTopic/CommercialMotorVehicles"
                        },
                        {
                            name: "Contributing Factors",
                            path: "/HighlightedTopic/ContributingFactors"
                        },
                        {
                            name: "Fatal Crash",
                            path: "/HighlightedTopic/FatalCrash"
                        },
                        {
                            name: "Hit & Run/Unknown Person",
                            path: "/HighlightedTopic/HitAndRun"
                        },
                        {
                            name: "Crash Investigation",
                            path: "/HighlightedTopic/CrashInvestigation"
                        },
                        {
                            name: "Crash Location",
                            path: "/HighlightedTopic/Location"
                        },
                        {
                            name: "Crash Narrative",
                            path: "/HighlightedTopic/Narrative"
                        },
                        {
                            name: "Occupant Protection",
                            path: "/HighlightedTopic/OccupantProtection"
                        },
                        {
                            name: "Private Property",
                            path: "/HighlightedTopic/PrivatePropertyCrashes"
                        },
                        // TODO: Verify if this location is desired
                        {
                            name: "Learning Module",
                            path: "/LearningModule"
                        }
                    ]
                },
                {
                    name: "Crash Specific Information",
                    path: "/SectionContent/CrashSpecificInformation",
                    children: [
                        {
                            name: "Crash Timeline",
                            path: "/SectionContent/CrashSpecificInformation#CrashTimeline"
                        },
                        {
                            name: "Units and Casualties",
                            path: "/SectionContent/CrashSpecificInformation#UnitsAndCasualties"
                        },
                        {
                            name: "Report Type",
                            path: "/SectionContent/CrashSpecificInformation#ReportType"
                        },
                        {
                            name: "Adminsitrative Fields",
                            path: "/SectionContent/CrashSpecificInformation#AdministrativeFields"
                        },
                        {
                            name: "Photos",
                            path: "/SectionContent/CrashSpecificInformation#Photos"

                        },
                        {
                            name: "Investigating Officer",
                            path: "/SectionContent/CrashSpecificInformation#InvestigatingOfficer"

                        },
                        {
                            name: "Reviewing Officer",
                            path: "/SectionContent/CrashSpecificInformation#ReviewingOfficer"
                        }
                    ]
                },
                {
                    name: "Crash Location",
                    path: "/SectionContent/CrashLocation",

                },
                {
                    name: "Unit/Operator Details",
                    path: "/SectionContent/UnitOperatorDetails",
                    children: [
                        {
                            name: "Unit Identification",
                            path: "/SectionContent/UnitOperatorDetails#UnitIdentification"
                        }, {
                            name: "Driver Information",
                            path: "/SectionContent/UnitOperatorDetails#DriverInformation"
                        }, {
                            name: "Driver License Information",
                            path: "/SectionContent/UnitOperatorDetails#DriverLicenseInformation"
                        }, {
                            name: "Insurance Information",
                            path: "/SectionContent/UnitOperatorDetails#InsuranceInformation"
                        }, {
                            name: "Operator Details",
                            path: "/SectionContent/UnitOperatorDetails#OperatorDetails"
                        },
                    ]
                },
                {
                    name: "Vehicle Details",
                    path: "/SectionContent/VehicleDetails",
                    children: [
                        {
                            name: "Vehicle Identification",
                            path: "/SectionContent/VehicleDetails#VehicleIdentification"
                        },
                        {
                            name: "Vehicle Removal",
                            path: "/SectionContent/VehicleDetails#VehicleRemoval"
                        },
                        {
                            name: "Vehicle/Unit Description",
                            path: "/SectionContent/VehicleDetails#VehicleUnitDescription"
                        },
                        {
                            name: "Unit Damage",
                            path: "/SectionContent/VehicleDetails#UnitDamage"
                        },

                    ]
                },
                {
                    name: "Collision Details & Circumstances",
                    path: "/SectionContent/CollisionDetails"
                },
                {
                    name: "Contributing Factors",
                    path: "/SectionContent/ContributingFactors"
                },
                {
                    name: "Roadway Details",
                    path: "/SectionContent/RoadwayDetails"
                },
                {
                    name: "Commercial Motor Vehicles",
                    path: "/SectionContent/CommercialMotorVehicles"
                },
                {
                    name: "Narrative",
                    path: "/SectionContent/Narrative"
                },
                {
                    name: "Diagram",
                    path: "/SectionContent/Diagram"
                },
                {
                    name: "Property Damage / Witness Information",
                    path: "/SectionContent/PropertyDamageWitnessInformation"
                },
                {
                    name: "Occupant Information",
                    path: "/SectionContent/OccupantInformation"
                },
                {
                    name: "Crash Report Forms",
                    path: "/SectionContent/CrashReportForms",
                    children: [
                        {
                            name: "GDOT-523 - Georgia Motor Vehicle Crash Report",
                            path: "/SectionContent/CrashReportForms#GDOT523GeorgiaMotorVehicleCrashReport"
                        }, {
                            name: "Overlay",
                            path: "/SectionContent/CrashReportForms#Overlay"
                        }, {
                            name: "GDOT-314 - FARS Early Traffic Fatality Notification Form",
                            path: "/SectionContent/CrashReportForms#GDOT314FARSEarlyTrafficFatalityNotificationForm"
                        },
                    ]
                },
                {
                    name: "Submitting a Crash Report",
                    path: "/SectionContent/SubmittingCrashReport",
                    children: [
                        {
                            name: "Submission Guidelines",
                            path: "/SectionContent/SubmittingCrashReport#SubmissionGuidelines"
                        }, {
                            name: "Crash Report Completion Assistance",
                            path: "/SectionContent/SubmittingCrashReport#CrashReportCompletionAssistance"
                        }, {
                            name: "Correcting a Previously Submitted Report",
                            path: "/SectionContent/SubmittingCrashReport#CorrectingAPreviouslySubmittedReport"
                        }, {
                            name: "Supplement to Original Report",
                            path: "/SectionContent/SubmittingCrashReport#SupplementToOriginalReport"
                        }, {
                            name: "Electronic Crash Report Database",
                            path: "/SectionContent/SubmittingCrashReport#ElectronicCrashReportDatabase"
                        },
                    ]
                },
                {
                    name: "Location Identification Tips",
                    path: "/SectionContent/LocationIdentificationTips",
                    children: [
                        {
                            name: "Identifying Intersection Crashes for Location at Area of Impact",
                            path: "/SectionContent/LocationIdentificationTips#IdentifyingIntersectionCrashesForLocationAtAreaOfImpact"
                        }, {
                            name: "Identifying Interstate Crash Location",
                            path: "/SectionContent/LocationIdentificationTips#IdentifyingInterstateCrashLocation"
                        }, {
                            name: "Locating Crashes on Interstate Entrance/Exit Ramp",
                            path: "/SectionContent/LocationIdentificationTips#LocatingCrashesOnInterstateEntranceExitRamp"
                        }, {
                            name: "Obtaining Crash GPS Location",
                            path: "/SectionContent/LocationIdentificationTips#ObtainingCrashGPSLocation"
                        },

                    ]
                },
                {
                    name: "Reporting Fatal Crashes",
                    path: "/SectionContent/ReportingFatalCrashes"
                },
                {
                    name: "Reporting Motor Vehicle Crashes with Trains",
                    path: "/SectionContent/ReportingCrashesWithTrains"
                },
                {
                    name: "Glossary",
                    path: "/SectionContent/Glossary"
                }, {
                    name: "Appendix - Validation Rules",
                    path: "https://crashmanual.s3.us-east-2.amazonaws.com/Validation+Error+List+for+Vendors+2024-01-26+dav.pdf"
                }

            ]
        };
    },
};


</script>

<style>
#left-nav {
    overflow-y: auto;
    background-color: #EEEFF0;
    border-right: 1px solid #dee2e6;
    cursor: pointer;
    width: 100%;
    z-index: 500;

}

/* remove nav element when printed */
@media print {
    #left-nav {
        display: none !important;
    }
}

@media screen and (min-width: 768px) {
    #left-nav {
        width: 300px;
        position: fixed;
        height: calc(100vh - 56px) !important;
    }

}
</style>